import classNames from 'classnames';
import EcoIconClose from 'eco-design-micro/icons/eco-icon-close';
import EcoVideo from 'eco-design/base/eco-video';
import React, { useEffect, useRef } from 'react';
import './index.scss';

interface EcoDialogVideoProps {
    /**
     * 是否开启
     */
    open: boolean;
    /**
     * 视频链接
     */
    src: string;
    /**
     * 是否是youtube视频链接
     */
    isYoutube?: boolean;
    /**
     * 关闭回调
     */
    callback?: any;
    /**
     * 样式名
     */
    className?: string;
}

const EcoDialogVideo: React.FC<EcoDialogVideoProps> = ({ open, src, isYoutube = true, className, callback }) => {
    const prefixCls = `eco-dialog-video`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const refDialog = useRef<any>(null);

    useEffect(() => {
        if (open) {
            refDialog.current.showModal();
        }
    }, [open]);

    // 关闭
    const closeHandle = () => {
        refDialog.current.close();
        if (callback) {
            callback();
        }
    };

    return (
        <dialog className={classes} ref={refDialog}>
            <div className={`${prefixCls}-in`}>
                {/* 避免 dialog 标签在浏览器不支持时视频直接出现在页面中心 */}
                {open && (
                    <>
                        {isYoutube && <iframe className={`${prefixCls}-iframe`} src={src}></iframe>}
                        {!isYoutube && <EcoVideo pc={src} className={`${prefixCls}-video`} />}
                    </>
                )}
            </div>
            <button className={`${prefixCls}-close`} onClick={closeHandle}>
                <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 512 512"
                    className="close-btn"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M256 48C140.559 48 48 140.559 48 256c0 115.436 92.559 208 208 208 115.435 0 208-92.564 208-208 0-115.441-92.564-208-208-208zm104.002 282.881l-29.12 29.117L256 285.117l-74.881 74.881-29.121-29.117L226.881 256l-74.883-74.881 29.121-29.116L256 226.881l74.881-74.878 29.12 29.116L285.119 256l74.883 74.881z"></path>
                </svg>
            </button>
        </dialog>
    );
};

export default EcoDialogVideo;
